import { render, staticRenderFns } from "./TypeOriginForm.vue?vue&type=template&id=f77e846a&"
import script from "./TypeOriginForm.vue?vue&type=script&lang=js&"
export * from "./TypeOriginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports